import { Button, Input, Modal, useErrorState } from '@finbeat/react-toolkit';
import { unloadRegistry } from 'axios/fundsTransferApi';
import useApi from 'hooks/useApi';
import { UnloadSetting } from 'models/api/fundsTransfer';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { List, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import 'scss/Main.scss';

type ModalUnloadRegistryProps = {
    toggle: () => void;
    settings: UnloadSetting[];
};

const ModalUnloadRegistry = ({ toggle, settings }: ModalUnloadRegistryProps) => {
    useTranslation();
    const api = useApi();
    const [ids, setIds] = useState<number[]>([]);
    const { handleRequestError } = useErrorState();

    const saveChanges = async () => {
        unloadRegistry(api, ids)
            .catch((e) => handleRequestError(e))
            .then(() => {
                toggle();
            });
    };

    const isValidForm = () => !!ids.length;

    return (
        <Modal isOpen={true} toggle={() => toggle()} scrollable className="brands__modal">
            <ModalHeader toggle={() => toggle()}>
                <Trans i18nKey="BackOfficeUnloadRegistry" />
            </ModalHeader>
            <ModalBody className="custom-scrollbar">
                <h6>
                    <Trans i18nKey="BackOfficeChooseUnloadSettings" />
                </h6>
                <List>
                    {settings.map((s, i) => (
                        <li key={i}>
                            <Input
                                type="checkbox"
                                label={s.name}
                                onChange={(e) => {
                                    if (s.id) {
                                        setIds(
                                            e.target.checked
                                                ? [...ids, s.id]
                                                : ids.filter((id) => id !== s.id)
                                        );
                                    }
                                }}
                            />
                        </li>
                    ))}
                </List>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => toggle()}>
                    <Trans i18nKey="BackOfficeCancel" />
                </Button>
                <Button color="success" disabled={!isValidForm()} onClick={() => saveChanges()}>
                    <Trans i18nKey="BackOfficeSave" />
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalUnloadRegistry;
